<template>
    <div>

        <el-form @submit.native.prevent="onSubmitMatriculaDireta" v-if="!editMatriculaDireta || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editMatriculaDireta || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">ALUNO</label>
                        <div class="style-input" style="background-color: #ebebeb !important;">{{ dados.aluno.nome }}</div>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Instituição *" prop="instituicao_id" :rules="[$requiredChange]" key="instituicao_id">
                            <el-select @change="changeInstituicaoAndCurso()" v-model="dados.instituicao_id" filterable>
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Período Letivo *" prop="periodo_letivo_id" :rules="[$requiredChange]" key="periodo_letivo_id">
                            <el-select @change="changeInstituicaoAndCurso()" v-model="dados.periodo_letivo_id">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Situação Matrícula *" prop="situacao_matricula" :rules="[$requiredChange]" key="situacao_matricula">
                            <el-select v-model="dados.situacao_matricula">
                                <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_MATRICULA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Situação Acadêmica *" prop="situacao_academica" :rules="[$requiredChange]" key="situacao_academica">
                            <el-select v-model="dados.situacao_academica">
                                <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_ACADEMICA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>              

                <el-row :gutter="10" v-if="dados.situacao_academica == 3">  
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Motivo da Evasão" key="motivo_evasao" prop="motivo_evasao">                
                            <el-input v-model="dados.motivo_evasao" v-mask="'##/##/####'"></el-input>
                        </el-form-item>                        
                    </el-col>                   
                </el-row>

                <el-row :gutter="10">
                   <el-col :xs="12" :sm="12" :md="12">
                        <el-form-item label="Data da Matrícula" key="data_matricula" prop="data_matricula">                
                            <el-input v-model="dados.data_matricula" v-mask="'##/##/####'"></el-input>
                        </el-form-item>                        
                    </el-col>    
                    <el-col :xs="12" :sm="12" :md="12">
                        <el-form-item label="Data da Trasnferência" key="data_transferencia" prop="data_transferencia">                
                            <el-input v-model="dados.data_transferencia" v-mask="'##/##/####'"></el-input>
                        </el-form-item>                        
                    </el-col>                   
                </el-row>
                 <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Nacional *" prop="referencia_nacional" key="referencia_nacional">
                            <el-select @change="getTurmas()" v-model="dados.referencia_nacional">
                                <el-option v-for="(curso, i) in cursosNacionais" :key="i" :label="curso.nome" :value="curso.referencia_nacional"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>                                       
                </el-row>
                <el-row :gutter="10" v-if="dados.situacao_matricula != 0">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma" prop="turma_id" key="turma_id">
                            <el-select v-model="dados.turma_id">
                                <el-option-group v-for="(curso, i) in turmas" :key="i" :label="i">
                                    <template v-for="item in curso">
                                       <el-option :key="item.id" :label="item.vagas_disponiveis" :value="item.id"></el-option>
                                    </template>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="danger" @click="closeDialog()">FECHAR</el-button>
                            <el-button type="primary" id="btn-modelo" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['aluno', 'matricula'],
    data: () => ({
        loading: false,
        editMatriculaDireta: false,
        dados:{
            id: '',
            instituicao_id: '',
            periodo_letivo_id: '',
            aluno: { id: '', nome: '', data_nascimento: '' },
            situacao_matricula: '',
            situacao_academica: '',
            aluno_id: '',
            referencia_nacional: '',
            turma_id: '',
            curso_id: '',
            data_matricula: '',
            data_transferencia: '',
            tipo_ensino: '',
            motivo_evasao: ''
        },
        cursosNacionais: [],
        turmas: []
    }),
    created(){

        if(Object.keys(this.matricula).length !== 0){

            this.dados.id = this.matricula.id;
            this.dados.instituicao_id = this.matricula.instituicao_id;
            this.dados.periodo_letivo_id = this.matricula.periodo_letivo_id;
            this.dados.situacao_matricula = this.matricula.situacao_matricula;
            this.dados.situacao_academica = this.matricula.situacao_academica;
            this.dados.aluno_id = this.matricula.aluno_id;
            this.dados.turma_id = this.matricula.turma_id;
            this.dados.tipo_ensino = this.matricula.tipo_ensino;
            this.dados.curso_id = this.matricula.curso_id;
            this.dados.referencia_nacional = this.matricula.referencia_nacional;
            this.dados.data_matricula = (this.matricula.data_matricula ? this.$moment(this.matricula.data_matricula).format('DD/MM/YYYY') : '');
            this.dados.data_transferencia = (this.matricula.data_transferencia ? this.$moment(this.matricula.data_transferencia).format('DD/MM/YYYY') : '');

            this.getRefNacional();
            this.getTurmas();         

            this.editMatriculaDireta = 1;
        }
    },
    methods:{
        changeInstituicaoAndCurso(){

            for(let i in this.$store.state.periodos){
                if(this.$store.state.periodos[i].id == this.dados.periodo_letivo_id){
                    this.dados.data_matricula = `01/01/${this.$store.state.periodos[i].nome}`;
                }
            }            

            this.dados.curso_id = '';
            this.dados.referencia_nacional = '';
            this.dados.turma_id = '';

            this.getRefNacional();
            this.getTurmas();
        },
        closeDialog(){
            this.$emit('onSubmitMatriculaDireta');
        },
        getRefNacional(){

            if(!this.dados.instituicao_id || !this.dados.periodo_letivo_id){

                return false;
            }

            window.eventBus.$emit('loading', true);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getRefNacionalByInstituicao`, {i: this.dados.instituicao_id, p: this.dados.periodo_letivo_id}, this.$store.getters.getHeaderAuth).then(response => {

                this.cursosNacionais = JSON.parse(JSON.stringify(response.data));
                window.eventBus.$emit('loading', false);

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmas(){

            if(!this.dados.instituicao_id || !this.dados.periodo_letivo_id || !this.dados.referencia_nacional){

                return false;
            }

            window.eventBus.$emit('loading', true);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllByReferenciaNacional`, {instituicao_id: this.dados.instituicao_id, periodo_letivo_id: this.dados.periodo_letivo_id, referencia_nacional: this.dados.referencia_nacional}, this.$store.getters.getHeaderAuth).then(response => {

                if(this.editMatriculaDireta != 1){

                    this.dados.turma_id = '';

                }else{

                    this.editMatriculaDireta = 2
                }

                this.turmas = response.data.turmas;
                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        onSubmitMatriculaDireta(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editMatriculaDireta == 1 || this.editMatriculaDireta == 2){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/updateMatriculaDireta/${this.dados.id}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitMatriculaDireta');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/novaMatriculaDireta`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitMatriculaDireta');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }

            }else{

                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
        formatData(field, size = null){

            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }

    },
    watch: {
        aluno: {
            immediate: true,
            handler (value) {

                if(value){

                    this.dados.aluno = JSON.parse(JSON.stringify(value));
                    this.dados.aluno_id = this.dados.aluno.id;
                }
            }
        }
    },
    components:{  }
}
</script>
